import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { endpoints } from '../../environments/endpoints';
import { LaravelDefaultResponse } from '../Interfaces/response.interface';
import { Onboarding } from '../Models/onboarding.model';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class OnboardingSessionService {
  private readonly _api = inject(ApiService);

  createSession(): Observable<Onboarding> {
    return this._api
      .post<LaravelDefaultResponse<Onboarding>>(endpoints.onboarding.session, {}, { skipLoading: true })
      .pipe(map(response => new Onboarding(response.data)));
  }
}
